import { DomainBuilder, DtoTeam } from '@web-portal/domains/shared/domain-models';
import { Team } from '../entities/team.entity';

export class TeamBuilder implements DomainBuilder {
  private readonly team: Team;

  constructor() {
    this.team = new Team();
  }

  withId(id: DtoTeam['id']): this {
    this.team.id = id ?? '';
    return this;
  }

  withName(name: DtoTeam['name']): this {
    this.team.name = name ?? '';
    return this;
  }

  withSlug(slug: DtoTeam['slug']): this {
    this.team.slug = slug ?? '';
    return this;
  }

  withIsMyTeam(isMyTeam: DtoTeam['ismyteam']): this {
    this.team.isMyTeam = isMyTeam ?? false;
    return this;
  }

  build(): Team {
    return this.team;
  }
}
